export const generateCustomStyleTag = (customStyles) => {
    if (!customStyles) return null;

    const parsedStyles = parseCustomStyles(customStyles);
    if (!parsedStyles) return null;

    const generateRule = (selector, styles) => {
      // Entferne den führenden Punkt für Klassennamen
      const className = selector.startsWith('.') ? selector.substring(1) : selector;

      // Erzeuge den CSS-Selektor basierend auf dem Typ
      let cssSelector;
      if (selector === 'body') {
        cssSelector = `body`;
      } else if (selector.startsWith('.')) {
        // Erhöhe die Spezifität für Klassenselektoren
        cssSelector = `html body .${className}.${className}`;
      } else {
        cssSelector = `html body ${selector}`;
      }

      // Stelle sicher, dass jede Deklaration !important hat
      const enhancedStyles = styles.split(';')
        .filter(Boolean)
        .map(declaration => {
          const trimmed = declaration.trim();
          return trimmed.endsWith('!important') ?
            trimmed + ';' :
            trimmed.endsWith(';') ?
              trimmed.slice(0, -1) + ' !important;' :
              trimmed + ' !important;';
        })
        .join(' ');

      return `${cssSelector} { ${enhancedStyles} }`;
    };

    const rules = [];

    // Verarbeite body zuerst
    if ('body' in parsedStyles) {
      rules.push(generateRule('body', parsedStyles['body']));
    }

    // Dann alle anderen Styles
    Object.entries(parsedStyles).forEach(([selector, styles]) => {
      if (selector !== 'body') {
        rules.push(generateRule(selector, styles));
      }
    });

    const finalCSS = rules.join('\n\n');

    return (
      <style dangerouslySetInnerHTML={{ __html: finalCSS }} />
    );
  };


export const parseCustomStyles = (rawStyles) => {
    if (!rawStyles) return null;

    try {
      const result = {};

      // Regex to match selector: "styles" pattern inside braces
      // Format: {body: "background: red", .card: "background: blue"}
      const styleRegex = /([a-zA-Z0-9._#-]+)\s*:\s*["']([^"']+)["']/g;
      let match;

      // Parse ALL occurrences - later styles override earlier ones
      while ((match = styleRegex.exec(rawStyles)) !== null) {
        let [, selector, styles] = match;

        // Clean up selector and styles
        selector = selector.trim();
        styles = styles.trim();

        // Later styles override earlier ones (same selector)
        result[selector] = styles;
      }

      return Object.keys(result).length > 0 ? result : null;
    } catch (error) {
      console.error('Parsing error:', error);
      return null;
    }
  };